import(/* webpackMode: "eager" */ "/opt/render/project/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["DebugPanel"] */ "/opt/render/project/src/components/DebugPanel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QueryProvider"] */ "/opt/render/project/src/components/providers/query-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/opt/render/project/src/components/theme-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/opt/render/project/src/components/ui/toaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ModelProvider"] */ "/opt/render/project/src/contexts/model-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/opt/render/project/src/lib/auth/auth-provider.tsx");
